export default __webpack_public_path__ + "static/media/pictogramTermDeposits48.91fb01e9.svg";